import { makeStyles } from "@material-ui/core/styles";
import { grey300 } from "../../../../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  row: {
    padding: theme.spacing(1),
    margin: theme.spacing(1),
    borderBottom: `1px solid ${grey300}`,
  },
  iconBox: {
    paddingRight: "8px",
    display: "inline-block",
  },
}));

export default useStyles;
